export function buildPageBatches(totalPages: number, pageBatchSize: number): number[][] {
    const res: number[][] = [];
    let temp: number[] = [];
    let index = 1;

    while (index <= totalPages) {
        temp.push(index);

        if (temp.length === pageBatchSize || index === totalPages) {
            res.push(temp);
            temp = [];
        }
        index += 1;
    }

    if (temp.length > 0) {
        res.push(temp);
    }

    return res;
}
